export const SET_QUOTE_CONFIRMATION_ID = 'SET_QUOTE_CONFIRMATION_ID';
export const SET_IS_QUOTE_APPT = 'SET_IS_QUOTE_APPT';
export const SET_READ_ONLY_SERVICES = 'SET_READ_ONLY_SERVICES';
export const SET_READ_ONLY_PACKAGE = 'SET_READ_ONLY_PACKAGE';
export const RESET_QUOTE_APPT = 'RESET_QUOTE_APPT';
export const SHOW_ERROR = 'SHOW_ERROR';



// WEBPACK FOOTER //
// ./src/store/reducers/quoteAppt/actionTypes.js